import React, { useState, useEffect, useRef, useContext } from 'react';
import './search_bar.component.css';
import SearchIcon from '../../../../assets/images/searchicon.svg';
import _ from 'lodash';
import { searchAll } from '../../../../api';
import AppContext from '../../../context';

const SearchBar = (props) => {
  const context = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(props.isStatic ? true : false);
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState({});
  const [selected, setSelected] = useState({});
  const input = useRef();
  const selectedSuggestion = useRef();
  const types = ['sector', 'companies', 'brands','InActive'];
  const [slugList, setSlugList] = useState([]);
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isShowSelected, setIsShowSelected] = useState(false);
  //statc search
  const [resultsVisible, setResultsVisible] = useState(false);

  const handleIconClick = (e) => {
    if (props.isStatic) return;
    if (isVisible) {
      setSearchTerm('');
      setResults({});
    }
    setIsVisible(!isVisible);
    if (window.innerWidth <= 840) {
      if (isVisible === false) {
        props.setIsSearchVisible(!isVisible);
      } else {
        setTimeout(() => {
          props.setIsSearchVisible(!isVisible);
        }, 400);
      }
    }
  };

  const handleSuggestionClick = (type, slug) => {
    if (!props.isStatic) setIsVisible(false);
    setSearchTerm('');
    setResults({});
    switch (type) {
      case 'sector':
        window.location = `/sector/${slug}`;
        break;
      case 'companies':
      case 'InActive':
        window.location = `/company/${slug}`;
        break;
      case 'brands':
        window.location = `/company/${slug}/#brands`;
        break;

      default:
        break;
    }
  };

  const handleSuggestionHover = (slug) => {
    setSelectedIdx(_.findIndex(slugList, (slugg) => slug === slugg.slug));
  };

  const handleInputBlur = (e) => {
    if (props.isStatic) setResultsVisible(false);
    e.target.nextSibling.style.display = 'none';
  };

  const handleInputFocus = (e) => {
    if (props.isStatic && !_.isEmpty(results)) setResultsVisible(true);
    e.target.nextSibling.style.display = 'block';
  };

  const handleKeyboard = (e) => {
    e.stopPropagation();
    switch (e.keyCode) {
      case 40:
        e.preventDefault();
        if (selectedIdx < slugList.length - 1) setSelectedIdx(selectedIdx + 1);
        break;
      case 38:
        e.preventDefault();
        if (selectedIdx > 0) setSelectedIdx(selectedIdx - 1);
        break;
      case 13:
        e.preventDefault();
        handleSuggestionClick(
          slugList[selectedIdx].data.type,
          slugList[selectedIdx].slug,
        );
        break;
      default:
        break;
    }
    if (e.keyCode === 40 || e.keyCode === 38) setIsShowSelected(true);
  };

  useEffect(() => {
    if (slugList.length)
      setSelected({
        slug: slugList[selectedIdx].slug,
        value: slugList[selectedIdx].value,
      });
  }, [selectedIdx]);

  useEffect(() => {
    if (selectedSuggestion.current)
      selectedSuggestion.current.scrollIntoView({ block: 'nearest' });
  }, [selected]);

  useEffect(() => {
    setIsShowSelected(false);
    if (!searchTerm) {
      setResults({});
      return;
    }
    const fetchResults = async () => {
      let searchResults = await searchAll(searchTerm);
      if (searchResults.data.length) {
        searchResults = searchResults.data.map((c) => {
          return {
            value: c.name,
            slug: c.slug,
            data: {
              type: c.type,
            },
          };
        });
        searchResults = _.groupBy(
          searchResults,
          (suggestion) => suggestion.data.type,
        );
        setResults(searchResults);
        const slugs = _.flatten(_.map(searchResults));
        setSlugList(slugs);
        setSelectedIdx(0);
      } else {
        setResults({});
      }
    };
    const debounce = setTimeout(() => fetchResults(), 300);
    return () => clearTimeout(debounce);
  }, [searchTerm]);

  useEffect(() => {
    if (props.isStatic) {
      if (_.isEmpty(results)) {
        setResultsVisible(false);
      } else {
        setResultsVisible(true);
      }
    }
    _.forEach(types, (type) => {
      if (_.has(results, type)) {
        setSelected({
          slug: results[type][0].slug,
          value: results[type][0].value,
        });
        return false;
      }
    });
  }, [results]);

  useEffect(() => {
    if (props.isStatic) return;
    if (isVisible) input.current.focus();
  }, [isVisible]);

  const getHighlightedSuggestion = (str) => {
    const searchTermLength = searchTerm.length;
    // Escaped special chars in RegEx
    str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    let searchText = searchTerm.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    const searchTermExp = new RegExp(searchText, 'gi');
    let matchedIdxs = [...str.matchAll(searchTermExp)].map(
      (matched) => matched['index'],
    );
    let splits = [];
    _.forEach(matchedIdxs, (idx) => {
      splits.push(idx);
      splits.push(idx + searchTermLength);
    });
    splits = [0, ...splits];
    return splits.map((split, idx, splits) =>
      str.slice(split, splits[idx + 1]),
    );
  };

  return (
    <div
      className={`${isVisible ? 'bar-border' : ''}${
        props.isStatic ? ' static-search' : ''
      }`}
    >
      <img
        src={SearchIcon}
        width="25px"
        className="header search-icon"
        onClick={handleIconClick}
      />
      <div className={`header-search ${isVisible ? 'show' : ''}`}>
        <input
          type="text"
          spellCheck="false"
          placeholder="Search for a company, sector or brand"
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={(e) => handleInputFocus(e)}
          onBlur={(e) => handleInputBlur(e)}
          onKeyDown={(e) => handleKeyboard(e)}
          value={isShowSelected ? selected.value : searchTerm}
          ref={input}
          className={props.isStatic && resultsVisible ? 'results-visible' : ''}
        />
        <div
          className={`suggestions ${
            props.isStatic && resultsVisible ? 'results-visible' : ''
          }`}
        >
          {results ? (
            types.map((type) => {
              if (_.has(results, type)) {
                return (
                  <div key={type}>
                    <div className="type">{type}</div>
                    <ul>
                      {results[type].map((suggestion) => {
                        return (
                          <li
                            key={suggestion.value}
                            onMouseDown={(e) =>
                              handleSuggestionClick(type, suggestion.slug)
                            }
                            onMouseOver={() =>
                              handleSuggestionHover(suggestion.slug)
                            }
                            className={
                              selected.value === suggestion.value
                                ? 'selected'
                                : ''
                            }
                            ref={
                              selected.slug === suggestion.slug
                                ? selectedSuggestion
                                : null
                            }
                          >
                            <span>
                              {getHighlightedSuggestion(suggestion.value).map(
                                (str, idx) => {
                                  if (
                                    str.toLowerCase() ===
                                    searchTerm.toLocaleLowerCase()
                                  )
                                    return <strong key={idx}>{str}</strong>;
                                  else return str;
                                },
                              )}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              }
            })
          ) : isVisible && searchTerm ? (
            <div className="no-suggestion">Sorry! No Companies found!</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
